const PdfTenantRow = ({ row }) => {
    return (
        <div className='pdf-row'>
            <div className='yearly-apt'>{row.ApartmentNumber}</div>
            <div className='yearly-apt'>{row.OwnerName}</div>
            <div className='yearly-apt'>{row.OwnerPhone}</div>
            <div className='yearly-apt'>{row.OwnerEmail}</div>
            <div className='yearly-apt'>{row.RenterName}</div>
            <div className='yearly-apt'>{row.RenterPhone}</div>
            <div className='yearly-apt'>{row.RenterEmail}</div>
            <div className='yearly-apt'>{row.monthlyFee}</div>
        </div>
    )
}

export default PdfTenantRow;